<template>
  <div class="dropzone">
    <p v-if="title" class="dropzone__title" :class="[titleSize]">
      {{ title }} <span v-if="isRequired" class="red">*</span>
    </p>
    <slot name="info" />
    <input
      ref="inputChangeRef"
      :accept="acceptTypes"
      type="file"
      class="dropzone__add-input"
      @change="onFileChange"
    >
    <ul ref="refImages" class="dropzone__images">
      <template v-if="images.length">
        <li
          v-for="(item, index) in images"
          :key="item.id"
          :style="{ height: `${height}px` }"
          class="dropzone__item"
        >
          <AppLoader v-if="item.isLoading" class="dropzone__loader" />
          <img :src="item.preview" class="dropzone__item-image">
          <div v-if="!item.isLoading" class="dropzone__item-actions">
            <button
              v-if="withChange"
              type="button"
              title="Изменить"
              class="dropzone__item-button"
              @click="editHandler(item.id)"
            >
              <SvgIcon icon="edit" />
            </button>
            <button
              v-if="withDelete"
              type="button"
              title="Удалить"
              class="dropzone__item-button --delete"
              @click="onDeleteImageClick(item.id)"
            >
              <SvgIcon icon="x" />
            </button>
          </div>
          <slot :index="index" name="form" />
        </li>
      </template>
      <li
        v-if="maxLength ? images?.length < maxLength : (!images?.length && !multiple) || multiple"
        class="dropzone__add"
        :style="{ height: `${height}px` }"
        @dragenter.prevent="toggleActive"
        @dragleave.prevent="toggleActive"
        @dragover.prevent
        @drop.prevent="onFilesDrop"
      >
        <label :for="`dropZoneFile-${keyItem || 'default'}`" class="dropzone__add-label">
          <SvgIcon icon="add-image" class="dropzone__add-icon" />
          <span class="dropzone__add-title">{{
            active ? 'Отпустите для загрузки' : dropzoneTitle
          }}</span>
          <span class="dropzone__add-description">{{ dropzoneDescription }}</span>
        </label>
        <input
          :id="`dropZoneFile-${keyItem || 'default'}`"
          ref="inputAddRef"
          :multiple="multiple"
          :accept="acceptTypes"
          type="file"
          class="dropzone__add-input"
          @change="onFileAdd"
        >
      </li>
    </ul>
  </div>
</template>

<script lang="ts" src="./AddImage.ts"></script>

<style scoped lang="scss" src="./AddImage.scss"></style>
